import * as React from 'react';
import { Store } from '../../stores';
import { inject, observer } from 'mobx-react';
import * as styles from './Playlists.css';
import { IACard } from '../../../card/Card';
import { IACardViewService } from '../../../messagesCardView/CardView.service';
import { LocalizationService } from '../../../../services/LocalizationService';
import { IListElement, IListElementColumn, IPlaylist } from '../../../../interfaces/IPlay';
import { IASpinner } from '../../../spinner/Spinner';
import { IAIconDropDown } from '../../../iconDropDown/IconDropDown';
import { PlayHelper } from '../../PlayHelper';
import { IIconDropDown } from '../../../../interfaces/IIconDropDown';
import { Helper } from '../../../../Helper';
import { IAButton } from '../../../button/Button';
import { IAListView } from '../../../listView/ListView';
import { IATextField } from '../../../textField/TextField';

export interface IProps {
  store?: Store;
  isLoading: boolean;
  getPlaylists: (searchQuery: string) => void;
  nextPage: () => void;
  elementActions?: {
    action: (id?: string) => void,
    actionName: string,
    icon: string,
    color: string
  }[];
}

export interface IState {
  selectedUserSorting?: IIconDropDown;
  searchQuery: string;
}

@inject('store')
@observer
export class PlaylistsContent extends React.Component<IProps, IState> {

  private readonly localizationService: LocalizationService = new LocalizationService();
  private cardViewService: IACardViewService = new IACardViewService();
  private queryDelay: NodeJS.Timeout;

  constructor(props: IProps) {
    super(props);
    this.state = {searchQuery: ""}
  }

  public render(): JSX.Element {
    const cards = [];
    const listElements: IListElement[] = [];
    // Resizing cards
    const [numberOfCardsPerRow, maxCardWidthAvailable] = this.cardViewService.getNumberOfCardsPerRowAndMaxCardWidthAvailable(this.props.store.contentWidth, 20, 250, 5);
    let currentRowNumber = 1;
    if (this.props.store.playlists && this.props.store.playlists.length > 0) {
      this.props.store.playlists.forEach((playlist: IPlaylist) => {
        let labels = [];
        if (playlist) {
          labels.push(
            {
              text: `${this.localizationService.strings.PlayAdmin_MenuArea_Slides}: ${playlist?.slides && playlist?.slides.length > 0 ? playlist?.slides.length : 0}`,
              icon: "Slides2",
              backgroundColor: this.props.store.darkMode ? "#232323" : "#e6e6e2",
              textColor: this.props.store.darkMode ? "#ffffff" : "#333333",
              borderRadius: 5
            }
          );
        }
        const columns: IListElementColumn[] = this.props.store.isMobile ?
          [
            {
              header: this.localizationService.strings.PlayAdmin_Title?.toUpperCase(),
              type: "text",
              text: playlist.title,
              color: this.props.store.darkMode ? "#ffffff" : "#333333"
            }
          ]
          :
          [
            {
              header: this.localizationService.strings.PlayAdmin_Title?.toUpperCase(),
              type: "text",
              text: playlist.title,
              color: this.props.store.darkMode ? "#ffffff" : "#333333"
            },
            {
              header: this.localizationService.strings.PlayAdmin_Modified?.toUpperCase(),
              type: "date",
              date: playlist.modified,
              color: this.props.store.darkMode ? Helper.darkModeLabelColor : "#777777"
            },
            {
              header: this.localizationService.strings.PlayAdmin_ModifiedBy?.toUpperCase(),
              type: "text",
              text: playlist.modifiedBy?.displayName,
              color: this.props.store.darkMode ? "#ffffff" : "#333333"
            }
          ];
        listElements.push(
          {
            id: playlist.id,
            columns: columns,
            buttons: this.props.elementActions?.map(element => {
              return {
                action: element.actionName,
                color: element.color,
                icon: element.icon
              };
            })
          }
        );
        cards.push(
          <IACard
            key={`player_${playlist.id}`}
            id={playlist.id}
            date={new Date(playlist.modified)}
            author={playlist.modifiedBy?.displayName}
            showSkeleton={false}
            title={playlist.title}
            darkMode={this.props.store.darkMode}
            cover={{
              imageURL: this.props.store.darkMode ? "https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/play/default-dark.jpg" : "https://intraactivestorage.blob.core.windows.net/cdn/SDK%20Images/play/default.jpg"
            }}
            labels={labels}
            width={window.innerWidth < 667 ? window.innerWidth - 56 : maxCardWidthAvailable}
            isMobile={this.props.store.isMobile}
            onClickOpen={() => {
              this.props.elementActions?.map(element => {
                if (element.actionName === "edit") {
                  element.action(playlist.id);
                }
              })
            }}
            alwaysShowFooter
            footerElements={this.props.elementActions?.map(element => {
              return {
                color: element.color,
                icon: element.icon,
                onClick: () => element.action(playlist.id)
              };
            })}
            styles={{
              marginRight: currentRowNumber == numberOfCardsPerRow ? 0 : 20,
              marginBottom: 20,
              width: window.innerWidth < 667 ? "100%" : maxCardWidthAvailable,
              color: this.props.store.darkMode ? "#ffffff" : "#333333"
            }}
            design={{
              highlightColor: this.props.store.highlightColor,
              showDropShadow: true,
              borderRadius: 5,
              backgroundColor: this.props.store.darkMode ? Helper.darkModeCardBackgroundColor : "#f6f6f5",
              hoverBackgroundColor: this.props.store.darkMode ? "#393939" : "#e6e6e6"
            }}
          />
        );

        if (currentRowNumber == numberOfCardsPerRow) {
          currentRowNumber = 1;
        } else {
          currentRowNumber++;
        }
      })
    }
    return (
      <>
        {!this.props.store.isMobile &&
          <div className={styles.IA_filters}>
            {/* <IAIconDropDown
              options={PlayHelper.getSortingOptions(this.localizationService)}
              selectedOption={localStorage.getItem("IA_playlistsSortingOption") ? JSON.parse(localStorage.getItem("IA_playlistsSortingOption")) : PlayHelper.getSortingOptions(this.localizationService)[0]}
              // label={this.localizationService.strings.PlayAdmin_Sorting}
              disabled
              darkMode={this.props.store.darkMode}
              onChange={(widgetsViewType: IIconDropDown) => {
                localStorage.setItem("IA_playlistsSortingOption", JSON.stringify(widgetsViewType));
                this.forceUpdate();
              }}
              style={{
                minWidth: 320,
                float: "left",
                marginRight: 20,
                marginBottom: 20,
                opacity: 0.5
              }}
            />
            <IAIconDropDown
              options={PlayHelper.getUserSortingOptions(this.localizationService)}
              selectedOption={this.state.selectedUserSorting}
              // label={this.localizationService.strings.PlayAdmin_UserSorting}
              disabled
              darkMode={this.props.store.darkMode}
              placeholder={this.localizationService.strings.PlayAdmin_UserSortingPlaceholder}
              clearable
              onChange={(selectedUserSorting: IIconDropDown) => this.setState({ selectedUserSorting }, () => this.props.getPlaylists())}
              style={{
                minWidth: 170,
                float: "left",
                marginRight: 20,
                marginBottom: 20,
                opacity: 0.5
              }}
            /> */}
            <IATextField
              style={{
                width: 330,
                marginRight: 20,
                marginTop: 0
              }}
              inputFieldStyle={{
                marginTop: 0,
                height: 38,
                borderColor: "#cccccc",
                fontSize: 15
              }}
              text={this.state.searchQuery}
              placeholder={this.localizationService.strings.PlayAdmin_SearchPlaylists}
              borderRadius={5}
              darkMode={this.props.store.darkMode}
              highlightColor={this.props.store.highlightColor}
              onChange={(search: string) => {
                this.setState({
                  searchQuery: search
                })
                clearTimeout(this.queryDelay);
                this.queryDelay = setTimeout(() => {
                  this.props.getPlaylists(this.state.searchQuery);
                }, 500);
              }}
            />
            <IAIconDropDown
              options={PlayHelper.getViewTypes()}
              selectedOption={localStorage.getItem("IA_playlistsViewType") ? JSON.parse(localStorage.getItem("IA_playlistsViewType")) : PlayHelper.getViewTypes()[0]}
              // label={this.localizationService.strings.PlayAdmin_ViewType}
              darkMode={this.props.store.darkMode}
              highlightColor={this.props.store.highlightColor}
              onChange={(widgetsViewType: IIconDropDown) => {
                localStorage.setItem("IA_playlistsViewType", JSON.stringify(widgetsViewType));
                this.forceUpdate();
              }}
              style={{
                minWidth: 70,
                marginBottom: 20,
                marginLeft: "auto"
              }}
            />
          </div>
        }
        <>
          {localStorage.getItem("IA_playlistsViewType") && JSON.parse(localStorage.getItem("IA_playlistsViewType")).value === "card" && !this.props.store.isMobile ?
            cards
            :
            <IAListView
              id="ListViewOfPlaylists"
              listElements={listElements}
              backgroundColor={this.props.store.darkMode ? Helper.darkModeCardBackgroundColor : "#f6f6f5"}
              hoverBackgroundColor={this.props.store.darkMode ? "#393939" : "#e6e6e6"}
              buttonAreaDividerColor={this.props.store.darkMode ? "#727272" : "#dcdcdc"}
              defaultAction={"edit"}
              darkMode={this.props.store.darkMode}
              selectedAction={(action: string, id: string) => {
                this.props.elementActions?.forEach((element) => {
                  if (element.actionName === action) {
                    element.action(id);
                  }
                });
              }}
            />
          }
          {!!this.props.nextPage && !this.props.isLoading &&
            <div className={styles.IA_paginationButtonContainer}>
              <IAButton
                onClick={() => this.props.nextPage()}
                buttonColor={this.props.store.highlightColor}
                darkMode={this.props.store.darkMode}
                textColor="#ffffff"
                borderRadius={5}
                label={this.localizationService.strings.PlayAdmin_LoadMore?.toUpperCase()}
              />
            </div>
          }
        </>
        {this.props.isLoading &&
          <IASpinner
            color={this.props.store.highlightColor}
            style={{
              float: "left",
              margin: "20px 0 0 calc(50% - 20px)"
            }}
          />
        }
      </>
    );
  }

  
}